import { render, staticRenderFns } from "./ShujuLaiyuanDetail.vue?vue&type=template&id=c1036654&scoped=true&"
import script from "./ShujuLaiyuanDetail.vue?vue&type=script&lang=js&"
export * from "./ShujuLaiyuanDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShujuLaiyuanDetail.vue?vue&type=style&index=0&id=c1036654&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1036654",
  null
  
)

export default component.exports